<template>
  <v-container>
    <v-row
      v-if="!Loading"
      justify="center">
      <v-col md="10">
        <v-container>
          <v-card>
            <v-toolbar
              color="primary"
              dark>
              <v-toolbar-title>
                <v-icon>contacts</v-icon>授業依頼を見る
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div v-if="this.offers.get().length != 0">
                <span class="text--primary">{{ this.offers.length() }}件の授業依頼があります。</span>
              </div>
              <div v-else>
                <span class="text--primary">現在授業依頼はありません。</span>
              </div>
            </v-card-text>
          </v-card>
        </v-container>
        <LessonRequestCard
          v-for="offer in this.offers.get()"
          :key="offer.id"
          :offer="offer"
          @removeLessonOffer="removeLessonOffer(offer)"
          @deleteLessonOffer="deleteLessonOffer(offer)"
        />
        <v-dialog
          v-model="acceptedDialog"
          persistent max-width="370"
        >
          <v-card>
            <v-card-title
              class="headline">
              授業依頼を引き受けました。
            </v-card-title>
            <v-card-text>　
              <span class="text--primary">引き受けた授業依頼は授業予定に反映されます。</span><br>
              <span class="text--primary">詳細はメッセージのやり取りを行ってください。</span>
            </v-card-text>
            <v-row
              row
              justify="center">
              <v-btn
                text
                class="mb-3"
                color="dark"
                @click="acceptedDialog=false">
                閉じる
              </v-btn>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="deniedDialog"
          persistent max-width="370"
        >
          <v-card>
            <v-container>
            <v-card-title
              class="headline">
              授業依頼を見送りました。
            </v-card-title>
            <v-card-text>
              <span class="text--primary">日時、報酬等の条件次第で検討される場合は、</span><br>
              <span class="text--primary">メッセージのやり取りで調整を行ってください。</span>
            </v-card-text>
            <v-row
              row justify="center">
              <v-btn
                text
                color="dark"
                class="mb-3"
                @click="deniedDialog=false">
                閉じる
              </v-btn>
            </v-row>
            </v-container>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row v-else>
      <Loading/>
    </v-row>
  </v-container>
</template>

<script>
import { firestore } from '@/repository/client/firestore.js'
import { ParentRepository } from '@/repository/ParentRepository.js'
import { LessonOfferRepository } from '@/repository/LessonOfferRepository.js'
import LessonRequestCard from '../../organisms/teacher/LessonRequestCard.vue'
import Loading from '@/components/organisms/Loading.vue'

export default {
  name:'LessonRequests',
  components: {
    'LessonRequestCard': LessonRequestCard,
    'Loading': Loading,
  },
  data() {
    return {
      teacher: this.$store.getters.teacher,
      offers: null,
      acceptedDialog: false,
      deniedDialog: false,
      Loading: true,
    }
  },
  methods: {
    removeLessonOffer(offer) {
      this.offers.remove(offer.id)
      this.acceptedDialog = true
    },
    deleteLessonOffer(offer) {
      this.offers.remove(offer.id)
      this.deniedDialog = true
    },
  },
  created: async function() {
    const offerRepo = new LessonOfferRepository(firestore)
    const parentRepo = new ParentRepository(firestore)
    this.offers = await offerRepo.listOfInOffer(this.teacher.uuid)
    this.Loading = false
  }
}

</script>
